import { css } from 'aphrodite';
import styles from './driver-card-styles';
import { RedButton } from '../common';

import React from 'react';

const moment = require('moment');

const DriverCardView = (props) => (
  <div className={css(styles.root)}>

    <img src={props.driver.image} className={css(styles.driverImg)} />
    <div style={{ padding: 8, paddingBottom: 4 }}>{props.driver.phone}</div>
    <div style={{ padding: 8, paddingBottom: 8, fontWeight: 'bold' }}>{`${props.driver.firstName} ${props.driver.lastName}`}</div>

    {props.driver.lastLocation && <div>
      <div style={{ padding: 8, paddingBottom: 2}}>Last updated:</div>
      <div style={{padding: 8, paddingBottom: 20}}>{moment(props.driver.lastLocation.timestamp).local().fromNow()}</div>
    </div>}

    <RedButton title={'Close'} onClick={props.removeCurrentDriverCardOnMap} />
  </div>
);

export default DriverCardView



// WEBPACK FOOTER //
// ./src/components/map-markers/driver-card-view.js